
import homeViewRouteRes from './home'


export default [
  ...homeViewRouteRes,
]



// WEBPACK FOOTER //
// ./src/router/mapping/index.js